'use strict'

OffersMap = require './offers_map'

$ ->
  el = '.mpp-container .offers-map-container'
  return unless $(el).length > 0

  $desktopWrapper = $ '.mpp-container .offers-map-desktop'
  $mobileWrapper = $ '.mpp-container .offers-map-mobile'

  place =  $('.mpp-container').data()

  new OffersMap {
    el: el
    $mobileWrapper: $mobileWrapper if $mobileWrapper.length > 0
    $desktopWrapper: $desktopWrapper if $desktopWrapper.length > 0
    place:
      id: place.placeId
      name: place.placeName
      lat: place.placeLat
      lon: place.placeLon
      streetAddress: place.placeStreetAddress
      category:
        singular: place.placeCategorySingular
      recommendations:
        total: place.placeRecommendationsTotal
        percentage: place.placeRecommendationsPercentage
    config: $(el).data 'config'
  }
